
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[slug]",
      function () {
        return require("private-next-pages/topics/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[slug]"])
      });
    }
  